class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');

      // 🔹 Cargar recomendaciones cada vez que se abre
  if (typeof loadCartRecommendations === "function") {
    loadCartRecommendations();
  }

}, 0);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

renderContents(parsedState) {
  this.productId = parsedState.id;

  /*
    IMPORTANTE:
    Si el carrito estaba vacío, el custom element queda con class="is-empty".
    Si no quitamos esa clase, el drawer puede actualizar totales pero no mostrar
    correctamente los productos hasta refrescar la página.
  */
  this.classList.remove('is-empty');

  const drawerInnerBefore = this.querySelector('.drawer__inner');
  if (drawerInnerBefore) {
    drawerInnerBefore.classList.remove('is-empty');
  }

  const drawerItemsBefore = this.querySelector('cart-drawer-items');
  if (drawerItemsBefore) {
    drawerItemsBefore.classList.remove('is-empty');
  }

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;

    sectionElement.innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  /*
    Repetimos después del render porque acabamos de reemplazar el HTML interno.
  */
  this.classList.remove('is-empty');

  const drawerInnerAfter = this.querySelector('.drawer__inner');
  if (drawerInnerAfter) {
    drawerInnerAfter.classList.remove('is-empty');
  }

  const drawerItemsAfter = this.querySelector('cart-drawer-items');
  if (drawerItemsAfter) {
    drawerItemsAfter.classList.remove('is-empty');
  }

  // 🚀 Integración de recomendaciones
  if (typeof loadCartRecommendations === "function") {
    loadCartRecommendations();
  }

  setTimeout(() => {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.open();
  });
}

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ---------------------------
// Snippet de recomendaciones
// ---------------------------
async function loadCartRecommendations() {
  const container = document.getElementById("cart-recommendations");
  if (!container) return;

  container.innerHTML = '<div class="cart-recommendations-spinner"></div>';

  try {
    const cartRes = await fetch("/cart.js");
    const cartData = await cartRes.json();
    const cartProductIds = cartData.items.map(item => item.product_id);

    const backendUrl = `https://shopify-api-krub.onrender.com/products?exclude=${cartProductIds.join(",")}`;
    const res = await fetch(backendUrl);
    const data = await res.json();

    if (!data.success || !data.products.length) {
      container.innerHTML = "<p style='text-align:center;'>No hay productos disponibles.</p>";
      return;
    }

    container.innerHTML = "";
    data.products.forEach(p => {
      const imgSrc = p.image || "https://via.placeholder.com/70";
      const item = document.createElement("div");
      item.className = "cart-recommendation-item";
      item.innerHTML = `
        <a href="/products/${p.handle}" class="cart-recommendation-link">
          <img src="${imgSrc}" alt="${p.title}" class="cart-recommendation-img">
          <span class="cart-recommendation-title">${p.title}</span>
        </a>
      `;
      container.appendChild(item);
    });

    const btnPrev = document.querySelector(".carousel-btn.prev");
    const btnNext = document.querySelector(".carousel-btn.next");
    btnPrev?.addEventListener("click", () => container.scrollBy({ left:-100, behavior:"smooth" }));
    btnNext?.addEventListener("click", () => container.scrollBy({ left:100, behavior:"smooth" }));

  } catch (err) {
    console.error("Error cargando recomendaciones:", err);
    container.innerHTML = "<p style='text-align:center;'>Error al cargar productos.</p>";
  }
}

// 🚀 Ejecutar al cargar la página
document.addEventListener("DOMContentLoaded", loadCartRecommendations);
